module.exports = __webpack_public_path__ + "static/media/stage11.0b4c9254.svg";